import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import authentication from './authentication';
import demo from './demo';

const rootReducer = combineReducers({
  authentication: persistReducer({
    key: 'authentication',
    storage,
  }, authentication),
  app: persistReducer({
    key: 'app',
    storage,
  }, app),
  demo,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts